import React from "react";
import { Form, Button } from "react-bootstrap";
import axios from "axios";
import validator from "validator";

export default class ServiceForm extends React.Component {
  constructor(props) {
    super(props);

    this.onNameChange = this.onNameChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onEmailChange = this.onEmailChange.bind(this);
    this.onMessageChange = this.onMessageChange.bind(this);
  }

  state = {
    name: "",
    email: "",
    message: "",
    statusMessage: "",
  };

  handleSubmit(e) {
    e.preventDefault();
    const name = this.state.name;
    const email = this.state.email;
    const message = this.state.message;

    if (!name || !email) {
      this.setState(() => {
        return { statusMessage: "Please provide name and email" };
      });
    } else if (!validator.isEmail(email)) {
      this.setState(() => {
        return { statusMessage: "Please provide a valid email" };
      });
    } else {
      //API Call
      axios
        .post("/api-curigma/v1/contacts", { name, email, message })
        .then((res) => {
          console.log(res);
          if (res.data.status === "success") {
            this.setState(() => {
              return { statusMessage: "We will contact you soon" };
            });
          }
        });
      this.setState(() => {
        return { message: "" };
      });
      e.elements.name.value = "";
      e.target.elements.email.value = "";
      e.target.elements.message.value = "";
    }
  }

  onNameChange(e) {
    const name = e.target.value;
    console.log(name);
    this.setState(() => {
      return { name };
    });
  }
  onEmailChange(e) {
    const email = e.target.value;
    console.log(email);
    this.setState(() => {
      return { email };
    });
  }
  onMessageChange(e) {
    const message = e.target.value;
    console.log(message !== "");
    if (message !== "") {
      console.log(message);
      this.setState(() => {
        return { message };
      });
    }
  }

  render() {
    return (
      <div>
        <Form className="form-container" onSubmit={this.handleSubmit}>
          <h1>
            <span>Get in touch</span>
          </h1>
          {this.state.statusMessage}
          <Form.Group className="m-2">
            <Form.Control
              type="text"
              placeholder="Name"
              minLength="4"
              name="name"
              onChange={this.onNameChange}
            />
          </Form.Group>
          <Form.Group className="m-2">
            <Form.Control
              type="text"
              placeholder="Your Email"
              name="email"
              onChange={this.onEmailChange}
            />
          </Form.Group>
          <Form.Group className="m-2">
            <Form.Control
              as="textarea"
              placeholder="Message"
              name="message"
              onChange={this.onMessageChange}
            />
          </Form.Group>
          <Button className="m-3" type="submit">
            Submit
          </Button>
        </Form>
      </div>
    );
  }
}
